import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

import {
  GetQuestionsApi,
  GetQuestionsApi_extrareducer,
  BureauAddressApi,
  BureauAddressApi_extrareducer,
  QuestionDecisionApi,
  QuestionDecisionApi_extrareducer,
  FetchCityStateApi,
  FetchCityStateApi_extrareducer,
} from './api/post-pan-api-calls/index';

const initialState = {
  allScreens: [],
  onScreenComp: ['WELCOME_SCR'],
  questionsList: {},
  detailsType: null,
  isPreFilled: false,
  formViewSubmission: false,
  journeyApproved: false,
  surrogateApproved: false,
  isInitialRender: {
    welcomeScreen: true,
    maritalStatusScreen: true,
    salaryScreen: true,
    workAddrScreen: true,
    homeAddrScreen: true,
    loadingScreen: true, // for questiondecision api call
  },
  getQuestionsApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  bureauAddressApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  questionDecisionApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  fetchCityStateApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  custJourneyAns: [
    {
      answer: {
        maritalStatus: null,
      },
      localAns: null,
      questionId: 5,
    },
    {
      answer: {
        incomeConsent: null,
        salary: null,
      },
      localAns: null,
      questionId: 7,
    },
    {
      answer: {
        EmployersName: null,
        addressLine1: null,
        landmark: null,
        addressType: null, //"SHORT"
        city: null,
        pin: null, //411014
        state: null,
      },
      localAns: null,
      questionId: 8,
    },
    {
      answer: {
        addressLine1: null,
        addressLine2: null,
        landmark: null,
        addressType: null, // "SHORT"
        city: null,
        pin: null, // 416416
        state: null,
      },
      localAns: null,
      questionId: 9,
    },
  ],
  isSubmitToggle: false,
  isValidated: {
    workAddr: false,
    homeAddr: false,
  },
  isSearchWorkAddrClosed: false,
  isSearchHomeAddrClosed: false,
  isHomeAddrUpdatedFromSearch: false,
  isWorkAddrUpdatedFromSearch: false,
  isSalaryConfirmed: false,
  isSalaryScreenUpdated: false,
  callQuesDecisionForSoftRejection: false,
  softRejectionFlag: false, // To store the data from getQuestions API
  // NOTE:If the user is softRejected we show the confirm your details screen which has to persisted if the user goes to diff screen and across differnt sessions as well
};

export const PostPanJourneySlice = createSlice({
  name: 'postPanJourney',
  initialState,
  reducers: {
    updateAllScreens: (state, action) => {
      state.allScreens.length = 0;
      state.allScreens = [...action.payload];
    },
    updateOnScreenComp: (state, action) => {
      state.onScreenComp.length = 0; // empty the array
      state.onScreenComp = [...action.payload];
    },
    updateQuestionsList: (state, action) => {
      state.questionsList = action.payload;
    },
    updateDetailsType: (state, action) => {
      state.detailsType = action.payload;
    },
    // TODO: Payload should be a obj eg:{questionId:1,anwser:{dob:"30/05/1997"}}
    updateCustJourneyAns: (state, action) => {
      const { questionId, answer } = action.payload;
      console.log('payload', { questionId, answer });
      const questionIndex = state.custJourneyAns.findIndex(
        (question) => question.questionId === questionId
      );
      state.custJourneyAns[questionIndex].answer = answer;
    },
    updatePreFilled: (state, action) => {
      state.isPreFilled = action.payload;
    },
    updateFormViewSubmission: (state, action) => {
      state.formViewSubmission = action.payload;
    },
    updateJourneyApproved: (state, action) => {
      state.journeyApproved = action.payload;
    },
    updateSurrogateApproved: (state, action) => {
      state.surrogateApproved = action.payload;
    },
    updateInitialScreenRender: (state, action) => {
      state.isInitialRender[action.payload] = false;
    },
    updateQuestionDecisionApiState: (state, action) => {
      state.questionDecisionApiState = action.payload;
    },
    updateSideDrawerState: (state, action) => {
      state.isSideDrawerOpen = action.payload;
    },
    updateSubmitBtnClick: (state, action) => {
      state.isSubmitToggle = action.payload;
    },
    updateValidated: (state, action) => {
      state.isValidated[action.payload] = true;
    },
    updateSearchWorkAddrClosed: (state) => {
      state.isSearchWorkAddrClosed = true;
    },
    updateSearchHomeAddrClosed: (state) => {
      state.isSearchHomeAddrClosed = true;
    },
    updateHomeAddrFromSearch: (state, action) => {
      state.isHomeAddrUpdatedFromSearch = action.payload;
    },
    updateWorkAddrFromSearch: (state, action) => {
      state.isWorkAddrUpdatedFromSearch = action.payload;
    },
    updateSalaryConfirmation: (state, action) => {
      console.log('Inside updateSalaryConfirmation');
      state.isSalaryConfirmed = action.payload;
    },
    updateIsSalaryScreenUpdated: (state, action) => {
      state.isSalaryScreenUpdated = action.payload;
    },
    updateSoftRejectionFlag: (state, action) => {
      state.softRejectionFlag = action.payload;
    },
    updateCallQuesDecisionForSoftRejection: (state, action) => {
      state.callQuesDecisionForSoftRejection = action.payload;
    },
    clearState: (state) => {
      // Note that is left intentionally empty.
      // Clearing redux state and localForage happens in rootReducer.
    },
  },
  extraReducers: {
    ...GetQuestionsApi_extrareducer,
    ...BureauAddressApi_extrareducer,
    ...QuestionDecisionApi_extrareducer,
    ...FetchCityStateApi_extrareducer,
  },
});

// export const selectIsSideDrawerOpen = (state) => state.PostPanJourneySlice.isSideDrawerOpen;

export function usePostPanStore() {
  const allScreens = useSelector((state) => state.postPanJourney.allScreens);
  const onScreenComp = useSelector(
    (state) => state.postPanJourney.onScreenComp
  );
  const isPreFilled = useSelector((state) => state.postPanJourney.isPreFilled);
  const journeyApproved = useSelector(
    (state) => state.postPanJourney.journeyApproved
  );
  const surrogateApproved = useSelector(
    (state) => state.postPanJourney.surrogateApproved
  );
  const formViewSubmission = useSelector(
    (state) => state.postPanJourney.formViewSubmission
  );
  const detailsType = useSelector((state) => state.postPanJourney.detailsType);
  const userInputs = useSelector(
    (state) => state.postPanJourney.custJourneyAns
  );
  const isInitialRender = useSelector(
    (state) => state.postPanJourney.isInitialRender
  );
  const isSubmitToggle = useSelector(
    (state) => state.postPanJourney.isSubmitToggle
  );
  const isValidated = useSelector((state) => state.postPanJourney.isValidated);
  const isSearchWorkAddrClosed = useSelector(
    (state) => state.postPanJourney.isSearchWorkAddrClosed
  );
  const isSearchHomeAddrClosed = useSelector(
    (state) => state.postPanJourney.isSearchHomeAddrClosed
  );
  const isHomeAddrUpdatedFromSearch = useSelector(
    (state) => state.postPanJourney.isHomeAddrUpdatedFromSearch
  );
  const isWorkAddrUpdatedFromSearch = useSelector(
    (state) => state.postPanJourney.isWorkAddrUpdatedFromSearch
  );
  const isSalaryConfirmed = useSelector(
    (state) => state.postPanJourney.isSalaryConfirmed
  );
  const isSalaryScreenUpdated = useSelector(
    (state) => state.postPanJourney.isSalaryScreenUpdated
  );
  const callQuesDecisionForSoftRejection = useSelector(
    (state) => state.postPanJourney.callQuesDecisionForSoftRejection
  );
  const softRejectionFlag = useSelector(
    (state) => state.postPanJourney.softRejectionFlag
  );
  // Api State
  const getQuestionsApiState = useSelector(
    (state) => state.postPanJourney.getQuestionsApiState
  );
  const bureauAddressApiState = useSelector(
    (state) => state.postPanJourney.bureauAddressApiState
  );
  const questionDecisionApiState = useSelector(
    (state) => state.postPanJourney.questionDecisionApiState
  );
  const fetchCityStateApiState = useSelector(
    (state) => state.postPanJourney.fetchCityStateApiState
  );
  const questionsList = useSelector(
    (state) => state.postPanJourney.questionsList
  );
  const dispatch = useDispatch();
  return {
    // state
    allScreens,
    onScreenComp,
    isPreFilled,
    journeyApproved,
    surrogateApproved,
    formViewSubmission,
    detailsType,
    userInputs,
    isInitialRender,
    isSubmitToggle,
    isValidated,
    isSearchWorkAddrClosed,
    isSearchHomeAddrClosed,
    isHomeAddrUpdatedFromSearch,
    isWorkAddrUpdatedFromSearch,
    isSalaryConfirmed,
    getQuestionsApiState,
    bureauAddressApiState,
    questionDecisionApiState,
    fetchCityStateApiState,
    isSalaryScreenUpdated,
    callQuesDecisionForSoftRejection,
    softRejectionFlag,
    questionsList,
    // reducers
    updateAllScreens: (screens) => dispatch(updateAllScreens(screens)),
    updateOnScreenComp: (screens) => dispatch(updateOnScreenComp(screens)),
    updateQuestionsList: (payload) => dispatch(updateQuestionsList(payload)),
    updatePreFilled: (payload) => dispatch(updatePreFilled(payload)),
    updateJourneyApproved: (payload) =>
      dispatch(updateJourneyApproved(payload)),
    updateSurrogateApproved: (payload) =>
      dispatch(updateSurrogateApproved(payload)),
    updateFormViewSubmission: (payload) =>
      dispatch(updateFormViewSubmission(payload)),
    updateDetailsType: (payload) => dispatch(updateDetailsType(payload)),
    updateCustJourneyAns: (userInput) =>
      dispatch(updateCustJourneyAns(userInput)),
    updateInitialScreenRender: (screen) =>
      dispatch(updateInitialScreenRender(screen)),
    updateQuestionDecisionApiState: (payload) =>
      dispatch(updateQuestionDecisionApiState(payload)),
    updateSubmitBtnClick: (payload) => dispatch(updateSubmitBtnClick(payload)),
    updateValidated: (addrScreen) => dispatch(updateValidated(addrScreen)),
    updateSearchWorkAddrClosed: () => dispatch(updateSearchWorkAddrClosed()),
    updateSearchHomeAddrClosed: () => dispatch(updateSearchHomeAddrClosed()),
    updateHomeAddrFromSearch: (payload) =>
      dispatch(updateHomeAddrFromSearch(payload)),
    updateWorkAddrFromSearch: (payload) =>
      dispatch(updateWorkAddrFromSearch(payload)),
    updateSalaryConfirmation: (payload) =>
      dispatch(updateSalaryConfirmation(payload)),
    updateIsSalaryScreenUpdated: (payload) =>
      dispatch(updateIsSalaryScreenUpdated(payload)),
    updateCallQuesDecisionForSoftRejection: (payload) =>
      dispatch(updateCallQuesDecisionForSoftRejection(payload)),
    resetQuestionDecisionApiState: () =>
      dispatch(resetQuestionDecisionApiState()),
    updateSoftRejectionFlag: (payload) =>
      dispatch(updateSoftRejectionFlag(payload)),
    // api_calls
    GetQuestionsApi: (payload) => dispatch(GetQuestionsApi(payload)),
    BureauAddressApi: (payload) => dispatch(BureauAddressApi(payload)),
    QuestionDecisionApi: (payload) => dispatch(QuestionDecisionApi(payload)),
    FetchCityStateApi: (payload) => dispatch(FetchCityStateApi(payload)),
  };
}

export const {
  updateAllScreens,
  updateOnScreenComp,
  updateQuestionsList,
  updatePreFilled,
  updateJourneyApproved,
  updateSurrogateApproved,
  updateFormViewSubmission,
  updateDetailsType,
  updateCustJourneyAns,
  updateInitialScreenRender,
  updateSubmitBtnClick,
  updateValidated,
  updateSearchWorkAddrClosed,
  updateSearchHomeAddrClosed,
  updateHomeAddrFromSearch,
  updateWorkAddrFromSearch,
  updateIsSalaryScreenUpdated,
  updateQuestionDecisionApiState,
  updateSalaryConfirmation,
  updateCallQuesDecisionForSoftRejection,
  resetQuestionDecisionApiState,
  updateSoftRejectionFlag,
  clearState,
} = PostPanJourneySlice.actions;

export default PostPanJourneySlice.reducer;
